/* eslint-disable default-case */
import { v4 as uuidv4 } from 'uuid';
import { STORAGE_BUCKET_BASE_URL } from 'constants/firebase';
import {
  MediaType,
  StorageFolder,
  ContentType,
  FileExtension,
} from 'models/forms';

export const buildPublicImageURL = (storageURI: string): string => {
  const items = storageURI.split('/');
  const fileName = items[items.length - 1];
  const imageURL = `${STORAGE_BUCKET_BASE_URL}/o/image%2F${fileName}?alt=media`;
  return imageURL;
};

export const buildFilePath = (storageURI: string, type: MediaType): string => {
  const folder = getStorageFolder(type);
  let fileName = '';
  if (type === MediaType.IMAGE) {
    const item = storageURI.split('image%2F')[1];
    [fileName] = item.split('?alt=media');
  } else {
    [, fileName] = storageURI.split(`${folder}/`);
  }
  const imagePath = `${folder}/${fileName}`;
  return imagePath;
};

export const getFileName = (rawFileName: string): string => {
  const splittedName = rawFileName.split('_');
  const fileName = splittedName.slice(1).join('_');
  return fileName;
};

export const getStorageFolder = (mediaType: MediaType): StorageFolder => {
  let result = null;
  switch (mediaType) {
    case MediaType.AUDIO:
      result = StorageFolder.AUDIO;
      break;
    case MediaType.IMAGE:
      result = StorageFolder.IMAGE;
      break;
    case MediaType.VIDEO:
      result = StorageFolder.VIDEO;
      break;
  }
  return result;
};

export const getContentType = (mediaType: MediaType): ContentType => {
  let result = null;
  switch (mediaType) {
    case MediaType.AUDIO:
      result = ContentType.WAV;
      break;
    case MediaType.IMAGE:
      result = ContentType.JPEG;
      break;
    case MediaType.VIDEO:
      result = ContentType.MP4;
      break;
  }
  return result;
};

export const getFileExtension = (mediaType: MediaType): FileExtension => {
  let result = null;
  switch (mediaType) {
    case MediaType.AUDIO:
      result = FileExtension.WAV;
      break;
    case MediaType.IMAGE:
      result = FileExtension.JPEG;
      break;
    case MediaType.VIDEO:
      result = FileExtension.MP4;
      break;
  }
  return result;
};

export const getFilePath = (
  mediaType: MediaType,
  fileName?: string,
): string => {
  let result = null;
  const uuid = uuidv4();
  const firebaseFileName = fileName
    ? `${uuid}_${encodeURIComponent(fileName)}`
    : `${uuid}`;
  switch (mediaType) {
    case MediaType.AUDIO:
      result = `${StorageFolder.AUDIO.toString()}/${firebaseFileName}`;
      break;
    case MediaType.IMAGE:
      result = `${StorageFolder.IMAGE.toString()}/${firebaseFileName}`;
      break;
    case MediaType.VIDEO:
      result = `${StorageFolder.VIDEO.toString()}/${firebaseFileName}`;
      break;
  }
  return result;
};
